var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99995 2.99417C8.23373 2.99417 8.42347 2.80443 8.42347 2.57064V1.72358C8.42347 1.48979 8.23373 1.30005 7.99995 1.30005C7.76616 1.30005 7.57642 1.48979 7.57642 1.72358V2.57064C7.57642 2.80443 7.76616 2.99417 7.99995 2.99417Z",
    fill: "#3DCF94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07064 8.07642H1.22358C0.98979 8.07642 0.800049 8.26616 0.800049 8.49995C0.800049 8.73373 0.98979 8.92347 1.22358 8.92347H2.07064C2.30443 8.92347 2.49417 8.73373 2.49417 8.49995C2.49417 8.26616 2.30443 8.07642 2.07064 8.07642Z",
    fill: "#3DCF94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1069 4.00718L3.50803 3.40831C3.34285 3.24313 3.07434 3.24313 2.90916 3.40831C2.74398 3.57348 2.74398 3.842 2.90916 4.00718L3.50803 4.60605C3.5902 4.68906 3.69862 4.73056 3.80704 4.73056C3.91547 4.73056 4.02389 4.68906 4.1069 4.60689C4.27208 4.44087 4.27208 4.1732 4.1069 4.00718Z",
    fill: "#3DCF94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7764 8.07642H13.9294C13.6956 8.07642 13.5059 8.26616 13.5059 8.49995C13.5059 8.73373 13.6956 8.92347 13.9294 8.92347H14.7764C15.0102 8.92347 15.2 8.73373 15.2 8.49995C15.2 8.26616 15.0102 8.07642 14.7764 8.07642Z",
    fill: "#3DCF94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.492 3.40831L11.8932 4.00718C11.728 4.17235 11.728 4.44087 11.8932 4.60605C11.9762 4.68906 12.0846 4.72972 12.193 4.72972C12.3015 4.72972 12.4099 4.68821 12.4929 4.60605L13.0918 4.00718C13.2569 3.842 13.2569 3.57348 13.0918 3.40831C12.9266 3.24313 12.6581 3.24313 12.492 3.40831Z",
    fill: "#3DCF94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97707 11.5092C10.9547 10.8655 11.6 9.75819 11.6 8.50015C11.6 6.51192 9.98825 4.90015 8.00002 4.90015C6.0118 4.90015 4.40002 6.51192 4.40002 8.50015C4.40002 9.75817 5.04531 10.8655 6.02294 11.5091C6.00795 11.5703 6 11.6343 6 11.7001V12.5001C6 12.9419 6.35817 13.3001 6.8 13.3001H9.2C9.64183 13.3001 10 12.942 10 12.5001V11.7001C10 11.6343 9.99205 11.5704 9.97707 11.5092Z",
    fill: "#3DCF94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84702 14.5H7.1529C6.91911 14.5 6.72937 14.6897 6.72937 14.9235C6.72937 15.1573 6.91911 15.3471 7.1529 15.3471H8.84702C9.08081 15.3471 9.27055 15.1573 9.27055 14.9235C9.27055 14.6897 9.08081 14.5 8.84702 14.5Z",
    fill: "#3DCF94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic_alert.2247461ade293020b8db87bfc0579efa.svg";
export { ForwardRef as ReactComponent };